import { createContext } from "react";
import type { MorphemeHrefObject } from "@-/dev.improve.haniverse.lib.morpheme.href.entities";

/** A card can own reference navigation without changing the surrounding route. */
export const MorphemeInlineNavigationContext = createContext<
  ((destination: { morpheme: string; prefix: MorphemeHrefObject }) => void) | null
>(null);
